<ngx-bootstrap-multiselect
    [settings]="settings"
    [texts]="texts"
    [options]="options"
    [(ngModel)]="tiposVendas"
    (ngModelChange)="onChange()"
    [disabled]="disabled">
</ngx-bootstrap-multiselect>